/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import { ThemeDataProvider } from './ThemeDataContext';
import { AuthProvider } from './AuthProvider';
import { PhotoBasicDataProvider } from './PhotoBasicDataContext';
import { CartProvider } from './CartProvider';
import { DownloadProvider } from './DownloadData';

/* Context providers*/
export const ContextProviders = ({ children, setJwtState }) => {
  return (
    <ThemeDataProvider>
      <AuthProvider setJwt={setJwtState}>
        <CartProvider>
          <PhotoBasicDataProvider>
            <DownloadProvider>{children}</DownloadProvider>
          </PhotoBasicDataProvider>
        </CartProvider>
      </AuthProvider>
    </ThemeDataProvider>
  );
};

export default React.memo(ContextProviders);
